import { Navigate } from 'react-router-dom';
import { useParams } from "react-router";
import {iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import CampusLogs from "./CampusLogs.jsx";
import { getSession } from "../services/session";
import { useForceLight } from "../contexts/ThemeContext.jsx";

const AuditLogs = (props) => {
    /* Unthemed V1 page. A migrated user can turn dark mode on in V2 and
       navigate here, so pin light while it is mounted. Does not change the
       stored preference. See docs/DARK_MODE_PLAN.md section 3. */
    useForceLight();

    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    dData = getSession();

    if (paramVars.dType === "campus" && iAmHigherAuthority(99, dData?.role_weight)){
        pageContent = <CampusLogs id={paramVars?.eType} />;
    }
    else{
        pageContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return iAmHigherAuthority(99, dData?.role_weight) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default AuditLogs;